var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#dashboard_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.173 1.983c3.015 1.338 5.3 3.096 6.48 4.112.598.513.93 1.252.972 2.038.057 1.08.125 2.77.125 4.617 0 1.422-.04 2.794-.085 3.872a2.37 2.37 0 0 1-2.297 2.28c-1.441.05-3.58.098-6.368.098-2.787 0-4.926-.05-6.368-.098a2.37 2.37 0 0 1-2.297-2.28 96 96 0 0 1-.085-3.872c0-1.848.069-3.537.125-4.617.042-.786.374-1.525.971-2.038C3.527 5.079 5.813 3.32 8.827 1.983a2.9 2.9 0 0 1 2.346 0M6.667 16.083h6.666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dashboard_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 .25h20v20H0z"
  })))));
};
export default SvgDashboard;